import type React from 'react';
import { Navigate } from 'react-router';

import { getRole } from 'api/tokenStorage';
import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { ErrorPage } from 'modules/E404/Error';
import { resolveSessionUnavailableCode } from 'modules/E404/errorCatalog';

const getHomeByRole = (roleString?: string, sessionRoles: number[] = []) => {
  if (roleString === 'tutor' && sessionRoles.includes(1)) return '/teacher';
  if (roleString === 'student' && sessionRoles.includes(2)) return '/profile/tasks';
  if (sessionRoles.includes(1)) return '/teacher';
  if (sessionRoles.includes(2)) return '/profile/tasks';
  return '/login';
};

export const RootRedirect: React.FC = () => {
  const { data: session, isLoading, isFetching, isError, error, refetch } = useAuthSession();

  if (isLoading || (isFetching && !session)) {
    return null;
  }

  if (isError && !session) {
    return (
      <ErrorPage
        code={resolveSessionUnavailableCode(error)}
        embedded
        onRetry={() => {
          void refetch();
        }}
      />
    );
  }

  if (!isAuthSessionActive(session)) {
    return <Navigate to='/login' replace />;
  }

  return (
    <Navigate
      to={getHomeByRole(getRole(), session?.roles ?? [])}
      replace
    />
  );
};
